function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    descriptor.value = value;
  }
}

function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }

  return privateMap.get(receiver);
}

function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}

function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration$p(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration$p(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
const AliasPrefix = 'pal';
const Entities = {
  Facility: 'facility',
  Organization: 'organization',
  Tenant: 'tenant',
  Unit: 'unit',
  Rental: 'rental',
  Reservation: 'reservation',
  Contact: 'contact',
  Coverage: 'coverage',
  Document: 'document'
};
const Providers = {
  SiteLink: 'sl',
  StorEdge: 'se',
  EasyStorage: 'ess'
};
const SpecVersion = '2.0.0';
var _subIds = /*#__PURE__*/new WeakMap();
class PolarisAlias {
  constructor() {
    _defineProperty(this, "entity", '');
    _defineProperty(this, "provider", '');
    _defineProperty(this, "value", '');
    _classPrivateFieldInitSpec(this, _subIds, {
      writable: true,
      value: null
    });
  }
  toString() {
    return "".concat(AliasPrefix, ":").concat(this.entity, ":").concat(this.provider, ":").concat(this.value);
  }
  get subIds() {
    if (!_classPrivateFieldGet(this, _subIds)) {
      _classPrivateFieldSet(this, _subIds, this.value.split(';'));
    }
    return _classPrivateFieldGet(this, _subIds);
  }
}

class PolarisAliasError extends Error {
  constructor(message) {
    super(message);
    this.name = 'PolarisAliasError';
  }
}

function _classPrivateMethodInitSpec$o(obj, privateSet) { _checkPrivateRedeclaration$o(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$o(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$o(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
const ContactTypes$1 = {
  Primary: 'primary',
  Alternate: 'alternate'
};
var _validate$o = /*#__PURE__*/new WeakSet();
class EasyStorageContactAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$o(this, _validate$o);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    _defineProperty(this, "customerId", -1);
    _defineProperty(this, "contactType", -1);
    this.entity = Entities.Contact;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$o(this, _validate$o, _validate2$o).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
    this.customerId = Number.parseInt(this.subIds[2]);
    this.contactType = this.subIds[3];
  }
}
function _validate2$o() {
  if (this.subIds.length != 4) {
    throw new PolarisAliasError("EasyStorageContactAlias expects 4 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageContactAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageContactAlias expects an integer as second sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError('Customer ID not a number. EasyStorageContactAlias expects an integer as third sub ID.');
  }
  const contactTypes = Object.values(ContactTypes$1);
  if (contactTypes.indexOf(this.subIds[3]) === -1) {
    throw new PolarisAliasError("Contact type not valid. EasyStorageContactAlias expects one of the following contact types: ".concat(contactTypes.join(', ')));
  }
}

function _classPrivateMethodInitSpec$n(obj, privateSet) { _checkPrivateRedeclaration$n(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$n(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$n(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$n = /*#__PURE__*/new WeakSet();
class EasyStorageFacilityAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$n(this, _validate$n);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    this.entity = Entities.Facility;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$n(this, _validate$n, _validate2$n).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
  }
}
function _validate2$n() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("EasyStorageFacilityAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageFacilityAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageFacilityAlias expects an integer as second sub ID.');
  }
}

function _classPrivateMethodInitSpec$m(obj, privateSet) { _checkPrivateRedeclaration$m(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$m(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$m(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$m = /*#__PURE__*/new WeakSet();
class EasyStorageOrganizationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$m(this, _validate$m);
    _defineProperty(this, "companyId", -1);
    this.entity = Entities.Organization;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$m(this, _validate$m, _validate2$m).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
  }
}
function _validate2$m() {
  if (this.subIds.length != 1) {
    throw new PolarisAliasError("EasyStorageOrganizationAlias expects 1 sub Id, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageOrganizationAlias expects an integer as first sub ID.');
  }
}

function _classPrivateMethodInitSpec$l(obj, privateSet) { _checkPrivateRedeclaration$l(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$l(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$l(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$l = /*#__PURE__*/new WeakSet();
class EasyStorageRentalAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$l(this, _validate$l);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    _defineProperty(this, "rentalId", -1);
    this.entity = Entities.Rental;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$l(this, _validate$l, _validate2$l).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
    this.rentalId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$l() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("EasyStorageRentalAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageRentalAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageRentalAlias expects an integer as second sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError('Rental ID not a number. EasyStorageRentalAlias expects an integer as third sub ID.');
  }
}

function _classPrivateMethodInitSpec$k(obj, privateSet) { _checkPrivateRedeclaration$k(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$k(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$k(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$k = /*#__PURE__*/new WeakSet();
class EasyStorageReservationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$k(this, _validate$k);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    _defineProperty(this, "reservationId", -1);
    this.entity = Entities.Reservation;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$k(this, _validate$k, _validate2$k).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
    this.reservationId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$k() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("EasyStorageReservationAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageReservationAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageReservationAlias expects an integer as second sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError('Reservation ID not a number. EasyStorageReservationAlias expects an integer as third sub ID.');
  }
}

function _classPrivateMethodInitSpec$j(obj, privateSet) { _checkPrivateRedeclaration$j(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$j(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$j(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$j = /*#__PURE__*/new WeakSet();
class EasyStorageTenantAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$j(this, _validate$j);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    _defineProperty(this, "customerId", -1);
    this.entity = Entities.Tenant;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$j(this, _validate$j, _validate2$j).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
    this.customerId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$j() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("EasyStorageTenantAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageTenantAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageTenantAlias expects an integer as second sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError('Customer ID not a number. EasyStorageTenantAlias expects an integer as third sub ID.');
  }
}

function _classPrivateMethodInitSpec$i(obj, privateSet) { _checkPrivateRedeclaration$i(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$i(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$i(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$i = /*#__PURE__*/new WeakSet();
class EasyStorageUnitAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$i(this, _validate$i);
    _defineProperty(this, "companyId", -1);
    _defineProperty(this, "facilityId", -1);
    _defineProperty(this, "unitId", -1);
    this.entity = Entities.Unit;
    this.provider = Providers.EasyStorage;
    this.value = str;
    _classPrivateMethodGet$i(this, _validate$i, _validate2$i).call(this);
    this.companyId = Number.parseInt(this.subIds[0]);
    this.facilityId = Number.parseInt(this.subIds[1]);
    this.unitId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$i() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("EasyStorageUnitAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (Number.isNaN(Number.parseInt(this.subIds[0]))) {
    throw new PolarisAliasError('Company ID not a number. EasyStorageUnitAlias expects an integer as first sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[1]))) {
    throw new PolarisAliasError('Facility ID not a number. EasyStorageUnitAlias expects an integer as second sub ID.');
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError('Unit ID not a number. EasyStorageUnitAlias expects an integer as third sub ID.');
  }
}

const capitalize$2 = str => str.charAt(0).toUpperCase() + str.slice(1);
class EasyStorageAliasBuilder {
  static build(entity, value) {
    const method = "build".concat(capitalize$2(entity), "Alias");
    if (!this[method]) {
      throw new PolarisAliasError("Don't know how to build entity: ".concat(entity));
    }
    return this[method](value);
  }
  static buildFacilityAlias(companyIdOrAliasValue, facilityId) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId);
    return new EasyStorageFacilityAlias(value);
  }
  static buildOrganizationAlias(companyId) {
    return new EasyStorageOrganizationAlias("".concat(companyId));
  }
  static buildTenantAlias(companyIdOrAliasValue, facilityId, customerId) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId, ";").concat(customerId);
    return new EasyStorageTenantAlias(value);
  }
  static buildUnitAlias(companyIdOrAliasValue, facilityId, unitId) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId, ";").concat(unitId);
    return new EasyStorageUnitAlias(value);
  }
  static buildRentalAlias(companyIdOrAliasValue, facilityId, rentalId) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId, ";").concat(rentalId);
    return new EasyStorageRentalAlias(value);
  }
  static buildReservationAlias(companyIdOrAliasValue, facilityId, reservationId) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId, ";").concat(reservationId);
    return new EasyStorageReservationAlias(value);
  }
  static buildContactAlias(companyIdOrAliasValue, facilityId, customerId, contactType) {
    const value = arguments.length == 1 ? companyIdOrAliasValue : "".concat(companyIdOrAliasValue, ";").concat(facilityId, ";").concat(customerId, ";").concat(contactType);
    return new EasyStorageContactAlias(value);
  }
}

function _classPrivateMethodInitSpec$h(obj, privateSet) { _checkPrivateRedeclaration$h(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$h(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$h(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
const ContactTypes = {
  Primary: 'primary',
  Alternate: 'alternate',
  Additional: 'additional',
  Business: 'business'
};
var _validate$h = /*#__PURE__*/new WeakSet();
class SiteLinkContactAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$h(this, _validate$h);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "tenantId", -1);
    _defineProperty(this, "contactType", '');
    this.entity = Entities.Contact;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$h(this, _validate$h, _validate2$h).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.tenantId = Number.parseInt(this.subIds[2]);
    this.contactType = this.subIds[3];
  }
}
function _validate2$h() {
  if (this.subIds.length != 4) {
    throw new PolarisAliasError("SiteLinkContactAlias expects 4 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkContactAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkContactAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("TenantID not integer. SiteLinkContactAlias expects an [int] value for third sub ID.");
  }
  const contactTypes = Object.values(ContactTypes);
  if (contactTypes.indexOf(this.subIds[3]) === -1) {
    throw new PolarisAliasError("Contact type not valid. SiteLinkContactAlias expects one of the following contact types: ".concat(contactTypes.join(', ')));
  }
}

function _classPrivateMethodInitSpec$g(obj, privateSet) { _checkPrivateRedeclaration$g(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$g(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$g(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$g = /*#__PURE__*/new WeakSet();
class SiteLinkCoverageAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$g(this, _validate$g);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "insurLedgerId", -1);
    this.entity = Entities.Coverage;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$g(this, _validate$g, _validate2$g).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.insurLedgerId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$g() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkCoverageAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkCoverageAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkCoverageAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("InsurLedgerID not integer. SiteLinkCoverageAlias expects an [int] value for third sub ID.");
  }
}

function _classPrivateMethodInitSpec$f(obj, privateSet) { _checkPrivateRedeclaration$f(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$f(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$f(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$f = /*#__PURE__*/new WeakSet();
class SiteLinkDocumentAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$f(this, _validate$f);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "documentId", -1);
    this.entity = Entities.Document;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$f(this, _validate$f, _validate2$f).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.documentId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$f() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkDocumentAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkDocumentAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkDocumentAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("DocumentID not integer. SiteLinkDocumentAlias expects an [int] value for third sub ID.");
  }
}

function _classPrivateMethodInitSpec$e(obj, privateSet) { _checkPrivateRedeclaration$e(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$e(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$e(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$e = /*#__PURE__*/new WeakSet();
class SiteLinkFacilityAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$e(this, _validate$e);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    this.entity = Entities.Facility;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$e(this, _validate$e, _validate2$e).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
  }
}
function _validate2$e() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("SiteLinkFacilityAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkFacilityAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkFacilityAlias expects a non-empty second sub ID.");
  }
}

function _classPrivateMethodInitSpec$d(obj, privateSet) { _checkPrivateRedeclaration$d(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$d(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$d(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$d = /*#__PURE__*/new WeakSet();
class SiteLinkOrganizationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$d(this, _validate$d);
    _defineProperty(this, "corpCode", '');
    this.entity = Entities.Organization;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$d(this, _validate$d, _validate2$d).call(this);
    this.corpCode = this.subIds[0];
  }
}
function _validate2$d() {
  if (this.subIds.length != 1) {
    throw new PolarisAliasError("SiteLinkOrganizationAlias expects 1 sub Id, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkOrganizationAlias expects a non-empty first sub ID.");
  }
}

function _classPrivateMethodInitSpec$c(obj, privateSet) { _checkPrivateRedeclaration$c(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$c(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$c(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$c = /*#__PURE__*/new WeakSet();
class SiteLinkRentalAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$c(this, _validate$c);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "ledgerId", -1);
    this.entity = Entities.Rental;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$c(this, _validate$c, _validate2$c).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.ledgerId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$c() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkRentalAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkRentalAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkRentalAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("LedgerID not integer. SiteLinkRentalAlias expects an [int] value for third sub ID.");
  }
}

function _classPrivateMethodInitSpec$b(obj, privateSet) { _checkPrivateRedeclaration$b(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$b(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$b(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$b = /*#__PURE__*/new WeakSet();
class SiteLinkReservationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$b(this, _validate$b);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "waitingId", -1);
    this.entity = Entities.Reservation;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$b(this, _validate$b, _validate2$b).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.waitingId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$b() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkReservationAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkReservationAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkReservationAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("WaitingID not integer. SiteLinkReservationAlias expects an [int] value for third sub ID.");
  }
}

function _classPrivateMethodInitSpec$a(obj, privateSet) { _checkPrivateRedeclaration$a(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$a(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$a(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$a = /*#__PURE__*/new WeakSet();
class SiteLinkTenantAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$a(this, _validate$a);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "tenantId", -1);
    this.entity = Entities.Tenant;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$a(this, _validate$a, _validate2$a).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.tenantId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$a() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkTenantAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkTenantAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkTenantAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("TenantID not integer. SiteLinkTenantAlias expects an [int] value for third sub ID.");
  }
}

function _classPrivateMethodInitSpec$9(obj, privateSet) { _checkPrivateRedeclaration$9(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$9(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$9(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$9 = /*#__PURE__*/new WeakSet();
class SiteLinkUnitAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$9(this, _validate$9);
    _defineProperty(this, "corpCode", '');
    _defineProperty(this, "locationCode", '');
    _defineProperty(this, "unitId", -1);
    this.entity = Entities.Unit;
    this.provider = Providers.SiteLink;
    this.value = str;
    _classPrivateMethodGet$9(this, _validate$9, _validate2$9).call(this);
    this.corpCode = this.subIds[0];
    this.locationCode = this.subIds[1];
    this.unitId = Number.parseInt(this.subIds[2]);
  }
}
function _validate2$9() {
  if (this.subIds.length != 3) {
    throw new PolarisAliasError("SiteLinkUnitAlias expects 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!this.subIds[0]) {
    throw new PolarisAliasError("CorpCode empty. SiteLinkUnitAlias expects a non-empty first sub ID.");
  }
  if (!this.subIds[1]) {
    throw new PolarisAliasError("LocationCode empty. SiteLinkUnitAlias expects a non-empty second sub ID.");
  }
  if (Number.isNaN(Number.parseInt(this.subIds[2]))) {
    throw new PolarisAliasError("UnitID not integer. SiteLinkUnitAlias expects an [int] value for third sub ID.");
  }
}

const capitalize$1 = str => str.charAt(0).toUpperCase() + str.slice(1);
class SiteLinkAliasBuilder {
  static build(entity, value) {
    const method = "build".concat(capitalize$1(entity), "Alias");
    if (!this[method]) {
      throw new PolarisAliasError("Don't know how to build entity: ".concat(entity));
    }
    return this[method](value);
  }
  static buildFacilityAlias(corpCodeOrAliasValue, locationCode) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode);
    return new SiteLinkFacilityAlias(value);
  }
  static buildOrganizationAlias(corpCode) {
    return new SiteLinkOrganizationAlias(corpCode);
  }
  static buildTenantAlias(corpCodeOrAliasValue, locationCode, tenantId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(tenantId);
    return new SiteLinkTenantAlias(value);
  }
  static buildUnitAlias(corpCodeOrAliasValue, locationCode, unitId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(unitId);
    return new SiteLinkUnitAlias(value);
  }
  static buildRentalAlias(corpCodeOrAliasValue, locationCode, ledgerId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(ledgerId);
    return new SiteLinkRentalAlias(value);
  }
  static buildReservationAlias(corpCodeOrAliasValue, locationCode, waitingId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(waitingId);
    return new SiteLinkReservationAlias(value);
  }
  static buildContactAlias(corpCodeOrAliasValue, locationCode, tenantId, contactType) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(tenantId, ";").concat(contactType);
    return new SiteLinkContactAlias(value);
  }
  static buildCoverageAlias(corpCodeOrAliasValue, locationCode, insurLedgerId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(insurLedgerId);
    return new SiteLinkCoverageAlias(value);
  }
  static buildDocumentAlias(corpCodeOrAliasValue, locationCode, documentId) {
    const value = arguments.length == 1 ? corpCodeOrAliasValue : "".concat(corpCodeOrAliasValue, ";").concat(locationCode, ";").concat(documentId);
    return new SiteLinkDocumentAlias(value);
  }
}

const uuidPattern = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const isValidUuid = str => {
  return uuidPattern.test(str);
};

function _classPrivateMethodInitSpec$8(obj, privateSet) { _checkPrivateRedeclaration$8(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$8(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$8(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$8 = /*#__PURE__*/new WeakSet();
class StorEdgeContactAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$8(this, _validate$8);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "tenantUuid", '');
    _defineProperty(this, "contactUuid", '');
    this.entity = Entities.Contact;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$8(this, _validate$8, _validate2$8).call(this);
    this.facilityUuid = this.subIds[0];
    this.tenantUuid = this.subIds[1];
    this.contactUuid = this.subIds[2];
  }
}
function _validate2$8() {
  if (this.subIds.length != 2 && this.subIds.length != 3) {
    throw new PolarisAliasError("StorEdgeContactAlias expects 2 or 3 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeContactAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Tenant ID not UUID. StorEdgeContactAlias expects a UUID as second sub ID.');
  }
  if (this.subIds[2] && !isValidUuid(this.subIds[2])) {
    throw new PolarisAliasError('Contact ID not UUID. StorEdgeContactAlias expects a UUID as third sub ID.');
  }
}

function _classPrivateMethodInitSpec$7(obj, privateSet) { _checkPrivateRedeclaration$7(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$7(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$7(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$7 = /*#__PURE__*/new WeakSet();
class StorEdgeCoverageAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$7(this, _validate$7);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "insuranceLedgerItemUuid", '');
    this.entity = Entities.Coverage;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$7(this, _validate$7, _validate2$7).call(this);
    this.facilityUuid = this.subIds[0];
    this.insuranceLedgerItemUuid = this.subIds[1];
  }
}
function _validate2$7() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeCoverageAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeCoverageAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError("InsuranceLedgerItemUUID not UUID. StorEdgeCoverageAlias expects a UUID as second sub ID.");
  }
}

function _classPrivateMethodInitSpec$6(obj, privateSet) { _checkPrivateRedeclaration$6(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$6(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$6(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$6 = /*#__PURE__*/new WeakSet();
class StorEdgeDocumentAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$6(this, _validate$6);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "eventDocumentUuid", '');
    this.entity = Entities.Document;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$6(this, _validate$6, _validate2$6).call(this);
    this.facilityUuid = this.subIds[0];
    this.eventDocumentUuid = this.subIds[1];
  }
}
function _validate2$6() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeDocumentAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeDocumentAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Event Document ID not UUID. StorEdgeDocumentAlias expects a UUID as second sub ID.');
  }
}

function _classPrivateMethodInitSpec$5(obj, privateSet) { _checkPrivateRedeclaration$5(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$5(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$5(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$5 = /*#__PURE__*/new WeakSet();
class StorEdgeFacilityAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$5(this, _validate$5);
    _defineProperty(this, "companyUuid", '');
    _defineProperty(this, "facilityUuid", '');
    this.entity = Entities.Facility;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$5(this, _validate$5, _validate2$5).call(this);
    this.companyUuid = this.subIds[0];
    this.facilityUuid = this.subIds[1];
  }
}
function _validate2$5() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeFacilityAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Company ID not UUID. StorEdgeFacilityAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeFacilityAlias expects a UUID as second sub ID.');
  }
}

function _classPrivateMethodInitSpec$4(obj, privateSet) { _checkPrivateRedeclaration$4(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$4(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$4(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$4 = /*#__PURE__*/new WeakSet();
class StorEdgeOrganizationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$4(this, _validate$4);
    _defineProperty(this, "companyUuid", '');
    this.entity = Entities.Organization;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$4(this, _validate$4, _validate2$4).call(this);
    this.companyUuid = this.subIds[0];
  }
}
function _validate2$4() {
  if (this.subIds.length != 1) {
    throw new PolarisAliasError("StorEdgeOrganizationAlias expects 1 sub Id, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError("Company ID not UUID (".concat(this.subIds[0], "). StorEdgeOrganizationAlias expects a UUID as first sub ID."));
  }
}

function _classPrivateMethodInitSpec$3(obj, privateSet) { _checkPrivateRedeclaration$3(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$3(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$3(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$3 = /*#__PURE__*/new WeakSet();
class StorEdgeRentalAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$3(this, _validate$3);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "ledgerUuid", '');
    this.entity = Entities.Rental;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$3(this, _validate$3, _validate2$3).call(this);
    this.facilityUuid = this.subIds[0];
    this.ledgerUuid = this.subIds[1];
  }
}
function _validate2$3() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeRentalAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeRentalAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Ledger ID not UUID. StorEdgeRentalAlias expects a UUID as second sub ID.');
  }
}

function _classPrivateMethodInitSpec$2(obj, privateSet) { _checkPrivateRedeclaration$2(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$2(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$2(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$2 = /*#__PURE__*/new WeakSet();
class StorEdgeReservationAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$2(this, _validate$2);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "leadUuid", '');
    this.entity = Entities.Reservation;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$2(this, _validate$2, _validate2$2).call(this);
    this.facilityUuid = this.subIds[0];
    this.leadUuid = this.subIds[1];
  }
}
function _validate2$2() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeReservationAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeReservationAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Lead ID not UUID. StorEdgeReservationAlias expects a UUID as second sub ID.');
  }
}

function _classPrivateMethodInitSpec$1(obj, privateSet) { _checkPrivateRedeclaration$1(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration$1(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet$1(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate$1 = /*#__PURE__*/new WeakSet();
class StorEdgeTenantAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec$1(this, _validate$1);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "tenantUuid", '');
    this.entity = Entities.Tenant;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet$1(this, _validate$1, _validate2$1).call(this);
    this.facilityUuid = this.subIds[0];
    this.tenantUuid = this.subIds[1];
  }
}
function _validate2$1() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeTenantAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeTenantAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Tenant ID not UUID. StorEdgeTenantAlias expects a UUID as second sub ID.');
  }
}

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
var _validate = /*#__PURE__*/new WeakSet();
class StorEdgeUnitAlias extends PolarisAlias {
  constructor(str) {
    super();
    _classPrivateMethodInitSpec(this, _validate);
    _defineProperty(this, "facilityUuid", '');
    _defineProperty(this, "unitUuid", '');
    this.entity = Entities.Unit;
    this.provider = Providers.StorEdge;
    this.value = str;
    _classPrivateMethodGet(this, _validate, _validate2).call(this);
    this.facilityUuid = this.subIds[0];
    this.unitUuid = this.subIds[1];
  }
}
function _validate2() {
  if (this.subIds.length != 2) {
    throw new PolarisAliasError("StorEdgeUnitAlias expects 2 sub Ids, ".concat(this.subIds.length, " found."));
  }
  if (!isValidUuid(this.subIds[0])) {
    throw new PolarisAliasError('Facility ID not UUID. StorEdgeUnitAlias expects a UUID as first sub ID.');
  }
  if (!isValidUuid(this.subIds[1])) {
    throw new PolarisAliasError('Unit ID not UUID. StorEdgeUnitAlias expects a UUID as second sub ID.');
  }
}

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
class StorEdgeAliasBuilder {
  static build(entity, value) {
    const method = "build".concat(capitalize(entity), "Alias");
    if (!this[method]) {
      throw new PolarisAliasError("Don't know how to build entity: ".concat(entity));
    }
    return this[method](value);
  }
  static buildFacilityAlias(companyUuidOrAliasValue, facilityUuid) {
    const value = arguments.length == 1 ? companyUuidOrAliasValue : "".concat(companyUuidOrAliasValue, ";").concat(facilityUuid);
    return new StorEdgeFacilityAlias(value);
  }
  static buildOrganizationAlias(organizationUuid) {
    return new StorEdgeOrganizationAlias(organizationUuid);
  }
  static buildTenantAlias(facilityUuidOrAliasValue, tenantUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(tenantUuid);
    return new StorEdgeTenantAlias(value);
  }
  static buildUnitAlias(facilityUuidOrAliasValue, unitUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(unitUuid);
    return new StorEdgeUnitAlias(value);
  }
  static buildRentalAlias(facilityUuidOrAliasValue, ledgerUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(ledgerUuid);
    return new StorEdgeRentalAlias(value);
  }
  static buildReservationAlias(facilityUuidOrAliasValue, leadUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(leadUuid);
    return new StorEdgeReservationAlias(value);
  }
  static buildContactAlias(facilityUuidOrAliasValue, tenantUuid, contactUuid) {
    let value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(tenantUuid);
    if (contactUuid) {
      value += ";".concat(contactUuid);
    }
    return new StorEdgeContactAlias(value);
  }
  static buildCoverageAlias(facilityUuidOrAliasValue, insuranceLedgerItemUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(insuranceLedgerItemUuid);
    return new StorEdgeCoverageAlias(value);
  }
  static buildDocumentAlias(facilityUuidOrAliasValue, eventDocumentUuid) {
    const value = arguments.length == 1 ? facilityUuidOrAliasValue : "".concat(facilityUuidOrAliasValue, ";").concat(eventDocumentUuid);
    return new StorEdgeDocumentAlias(value);
  }
}

const AliasPattern = /^pal:([a-z]*):([a-z]{2,3}):([^;:]+(?:;[^;:]+)*)$/;
class PolarisAliasBuilder {
  static parse(str) {
    if (!str) {
      throw new PolarisAliasError("Invalid alias: ".concat(str));
    }
    const match = str.match(AliasPattern);
    if (!match || match.length != 4) {
      throw new PolarisAliasError("Invalid alias: ".concat(str));
    }
    const [, entity, provider, value] = match;
    switch (provider) {
      case Providers.SiteLink:
        return SiteLinkAliasBuilder.build(entity, value);
      case Providers.StorEdge:
        return StorEdgeAliasBuilder.build(entity, value);
      case Providers.EasyStorage:
        return EasyStorageAliasBuilder.build(entity, value);
      default:
        throw new PolarisAliasError("Unknown provider: ".concat(provider));
    }
  }
}

export { EasyStorageAliasBuilder, Entities, PolarisAlias, PolarisAliasBuilder, PolarisAliasError, Providers, SiteLinkAliasBuilder, SpecVersion, StorEdgeAliasBuilder };
//# sourceMappingURL=index.js.map
